/**
 * 指定されたIDの要素までスクロールする
 * @param sectionId スクロール先の要素のID
 * @returns スクロールが成功したかどうか
 */
export const scrollToElement = (sectionId: string): boolean => {
  const element = document.getElementById(sectionId)
  if (element) {
    const elementPosition =
      element.getBoundingClientRect().top + window.scrollY
    const offsetPosition = elementPosition
    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth',
    })
    return true
  }
  return false
}
